
import Vue from 'vue';

export interface IFileUploader {
  open: () => void;
  reset: () => void;
}

export default Vue.extend({
  name: 'FileUpload',
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: 'image/*',
    },
  },
  methods: {
    handleFilesChange(name: string, files: File[]) {
      this.$emit('change', { name, files });
    },
    open() {
      (this.$refs.file as HTMLInputElement).click();
    },
    reset() {
      (this.$refs.file as HTMLInputElement).value = '';
    },
  },
});
